(function () {
  'use strict';

  var ns = window.__nensons = window.__nensons || {};
  if (typeof ns.renderedAsLoggedIn === 'undefined') return;

  var renderedAsLoggedIn = !!ns.renderedAsLoggedIn;
  var reloadScheduled    = false;

  function isPrivateMode() {
    try {
      var k = '__sg_private_test__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
      return false;
    } catch (e) {
      return true;
    }
  }

  // ONLY fires on bfcache restores (back/forward navigation)
  // Fresh page loads are always correct — Liquid just rendered them server-side
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return; // fresh load — skip entirely
    if (reloadScheduled)     return;
    if (isPrivateMode())     return;

    reloadScheduled = true;

    fetch('/account?_=' + Date.now(), {
      method:      'GET',
      credentials: 'include',
      cache:       'no-store',
      redirect:    'manual'
    })
    .then(function (res) {
      var isOpaque     = (res.type === 'opaqueredirect');
      var urlIsLogin   = (res.url && res.url.indexOf('/account/login') !== -1);
      var liveLoggedIn = !isOpaque && !urlIsLogin && (res.status === 200 || res.status === 0);
      if (res.status === 0 && isOpaque) liveLoggedIn = false;

      if (liveLoggedIn !== renderedAsLoggedIn) {
        window.location.reload();
      } else {
        reloadScheduled = false;
      }
    })
    .catch(function () {
      reloadScheduled = false;
    });
  });

})();